(function() {
    'use strict';

    angular
        .module('completeAir')
        .controller('revenueProductionConnectionCtrl', revenueProductionConnectionCtrl)
        .controller('modalOversoldCtrl', modalOversoldCtrl)
        .controller('modalDeactivateActivateClassesCtrl', modalDeactivateActivateClassesCtrl);

    revenueProductionConnectionCtrl.$inject = ['$stateParams', 'linkService','tabRevenue','connections','datePickerService',
        '$timeout','categories','$uibModal','revenueProductionService','AuthServerProvider'];

    modalOversoldCtrl.$inject = ['linkService', '$uibModal', '$uibModalInstance', 'indexX', 'categories', 'categoriesIds', 'segments',
        'isModal', 'revenueProductionService', 'AuthServerProvider'];

    modalDeactivateActivateClassesCtrl.$inject = ['linkService', '$uibModal', '$uibModalInstance', 'categories',
        'activateDeactivateClasses', 'isModal', 'revenueProductionService','connection','AuthServerProvider'];

    function revenueProductionConnectionCtrl($stateParams, linkService, tabRevenue, connections, datePickerService,
                                             $timeout,categories,$uibModal,revenueProductionService,AuthServerProvider) {
        var vm = this;
        vm.userAccount = AuthServerProvider.getUserAccount();
        vm.linkService = linkService;
        vm.$uibModal = $uibModal;
        vm.tabs = tabRevenue;
        vm.connections = connections;
        vm.categories = categories;
        vm.editIndexX = -1;

        vm.dateConnection = {
            'departureDate': ($stateParams.departureDate != "") ? new Date(parseInt($stateParams.departureDate)) : new Date()
        };
        vm.datePickerOpenStatus = {'date': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false
            },
            closed: function(args) {
                if(args.closeDate != ""){
                    vm.changeDay();
                }
            }
        };
        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.changeDay = function(){
            $timeout(function(){
                var date = vm.dateConnection.departureDate;
                if(date != undefined){
                    var dateTime = date.getTime();
                    linkService.reloadRoute(linkService.getCurrentRouteName(), {departureDate: dateTime})
                }
            }, 100);
        }
        for(var i=0; i<vm.connections.length; i++){
            vm.connections[i].segmentClasses = [];
            vm.connections[i].disabledClass = true;
            vm.connections[i].disabledEdit = false;
            vm.connections[i].showEdit = true;
            vm.connections[i].showSave = false;
            for(var c=0; c<categories.length; c++){
                for(var cl=0; cl<categories[c]._embedded.fareClasses.length; cl++){
                    var classId = linkService.getLinkId(categories[c]._embedded.fareClasses[cl]._links.self.href);
                    var indexClass = getIndexClass(classId,vm.connections[i]._embedded.segmentflights[0]._embedded.segmentClasses);
                    vm.connections[i].segmentClasses.push(
                        {
                            "segmentClassId": parseInt(vm.linkService.getLinkId(vm.connections[i]._embedded.segmentflights[0]._embedded.segmentClasses[indexClass]._links.self.href)),
                            "classId": classId,
                            "value": vm.connections[i]._embedded.segmentflights[0]._embedded.segmentClasses[indexClass].value,
                            "active": vm.connections[i]._embedded.segmentflights[0]._embedded.segmentClasses[indexClass].active,
                            "segmentFlightId": parseInt(vm.linkService.getLinkId(vm.connections[i]._embedded.segmentflights[0]._links.self.href)),
                            "takeOffCapacity": parseInt(vm.connections[i]._embedded.segmentflights[0].takeOffCapacity)
                        }
                    );
                }
            }
        }

        vm.editSegmentClasses = function (indexX) {
            if (vm.editIndexX == indexX || vm.editIndexX == -1) {
                vm.connections[indexX].disabledClass = false;
                vm.connections[indexX].showEdit = false;
                vm.editIndexX = indexX;
                vm.auxSegments = angular.copy(vm.connections[indexX].segmentClasses);
            }
        }

        vm.cancelSegmentClasses = function (indexX) {
            vm.connections[indexX].segmentClasses = angular.copy(vm.auxSegments);
            vm.connections[indexX].disabledClass = true;
            vm.connections[indexX].showEdit = true;
            vm.editIndexX = -1;
            vm.auxSegments = [];
        }

        vm.saveSegmentClasses = function (valid, indexX) {
            if (valid) {
                revenueProductionService.updateSegmentItineraries({"segmentClasses": vm.connections[indexX].segmentClasses}, vm.userAccount.userName)
                    .then(function (res) {
                        if (res != "ok") {
                            vm.connections[indexX].segmentClasses = angular.copy(vm.auxSegments);
                        }
                        vm.connections[indexX].disabledClass = true;
                        vm.connections[indexX].showEdit = true;
                        vm.editIndexX = -1;
                        vm.auxSegments = [];
                    });
            }
        }

        vm.openOversoldDialog = function (indexX, segmentFlight) {

            var segmentFlightId = 0;

            if (segmentFlight.overLoad) {
                segmentFlightId = parseInt(linkService.getLinkId(segmentFlight._links.self.href));

            }
            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/configGeneral/rates/revenue/revenueProduction/oversold.html',
                controller: 'modalOversold',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    'indexX': [function () {
                        return indexX
                    }],
                    'categories': ['tariffClassService', function (tariffClassService) {
                        return tariffClassService.getFareClassesFare();
                    }],
                    'categoriesIds': ['itineraryService',function (itineraryService) {
                        return itineraryService.getOverLoad(linkService.getLinkId(segmentFlight._links.self.href));
                    }],
                    'segments': [function () {
                        return segmentFlight
                    }],
                    'dataModalObj': [function () {
                        return segmentFlightId;
                    }],
                    'isModal': 1
                }
            });
            modalInstance.result.then(function (res) {
            }, function () {
                linkService.reloadRoute(linkService.getCurrentRouteName(), {departureDate: $stateParams.departureDate})
            });
        }

        vm.openActivateDeactivateClassesDialog = function (indexX, connection) {

            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/configGeneral/rates/revenue/revenueProduction/activateDeactivateClasses.html',
                controller: 'modalDeactivateActivateClassesCtrl',
                controllerAs: 'vm',
                resolve: {
                    'categories': ['tariffClassService', function (tariffClassService) {
                        return tariffClassService.getFareClassesFare();
                    }],
                    'activateDeactivateClasses': ['itineraryService',function (itineraryService) {
                        return itineraryService.getOverLoad(linkService.getLinkId(connection._embedded.segmentflights[0]._links.self.href));
                    }],
                    'connection': [function () {
                        return connection
                    }],
                    'isModal': 1
                }
            });
            modalInstance.result.then(function (res) {
            }, function () {
                linkService.reloadRoute(linkService.getCurrentRouteName(), {departureDate: $stateParams.departureDate})
            });
        }
    }

    function modalOversoldCtrl(linkService, $uibModal, $uibModalInstance, indexX, categories, categoriesIds, segments,
                           isModal, revenueProductionService, AuthServerProvider) {

        var vm = this;

        vm.indexX = indexX;

        vm.categories = categories;

        vm.selectCheckbox = [];

        for(var k=0; k<categoriesIds._embedded.segmentClasses.length; k++){
            vm.selectCheckbox.push({
                "true": true
            })
        }

        vm.$uibModal = $uibModal;

        vm.oversold = {};

        vm.isModal = isModal;

        vm.segments = segments;

        vm.oversold.selectCheckBox = [];
        vm.oversold.segmentClasses = [];

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.userAccount = AuthServerProvider.getUserAccount();

        vm.categoriesIds = categoriesIds;
        vm.oversold.overLoad = categoriesIds.overLoad;
        vm.oversold.segmentFlightId = linkService.getLinkId(vm.categoriesIds._links.self.href)
        for(var i =0; i<vm.categories.length; i++){
            for(var j=0; j<vm.categories[i]._embedded.fareClasses.length; j++){
                for(var k=0; k<categoriesIds._embedded.segmentClasses.length; k++){
                    if(linkService.getLinkId(vm.categories[i]._embedded.fareClasses[j]._links.self.href)==categoriesIds._embedded.segmentClasses[k].classId){
                        vm.oversold.selectCheckBox.push(true);
                        vm.oversold.segmentClasses.push({
                            "segmentClassId": categoriesIds._embedded.segmentClasses[k].classId,
                            "hasOverSold": categoriesIds._embedded.segmentClasses[k].hasOverSold
                        });
                    }
                }
            }
        }

        vm.saveOversold = function (isValid, saveOversold) {
            if (isValid) {
                revenueProductionService.updateOversold(saveOversold, vm.userAccount.userName)
                    .then(function (result) {
                        vm.cancel();
                    });
            }
        }
    }

    function modalDeactivateActivateClassesCtrl(linkService, $uibModal, $uibModalInstance, categories,
                                            activateDeactivateClasses, isModal,revenueProductionService,connection, AuthServerProvider) {

        var vm = this;

        vm.isConnection = true;
        vm.categories = categories;
        vm.$uibModal = $uibModal;
        vm.isModal = isModal;
        vm.activateDeactivate = [];

        vm.userAccount = AuthServerProvider.getUserAccount();

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.segments = [
            {
                '_embedded': {
                    'segment': connection._embedded.segment,
                    'segmentClasses': connection._embedded.segmentflights[0]._embedded.segmentClasses,
                    'routeName': connection._embedded.route.name
                }
            }
        ];

        vm.activateDeactivate = [
            {
                'segmentFlight': parseInt(linkService.getLinkId(activateDeactivateClasses._links.self.href)),
                'selectCheckBox': [],
                'segmentClassIds': []
            }
        ];

        for(var i =0; i<vm.categories.length; i++){
            for(var j=0; j<vm.categories[i]._embedded.fareClasses.length; j++){
                for(var k=0; k<activateDeactivateClasses._embedded.segmentClasses.length; k++){
                    if(linkService.getLinkId(vm.categories[i]._embedded.fareClasses[j]._links.self.href)==activateDeactivateClasses._embedded.segmentClasses[k].classId){
                        vm.activateDeactivate[0].segmentClassIds.push({
                            "data": activateDeactivateClasses._embedded.segmentClasses[k].active,
                            "active": activateDeactivateClasses._embedded.segmentClasses[k].active,
                            "segmentClassId": parseInt(linkService.getLinkId(activateDeactivateClasses._embedded.segmentClasses[k]._links.self.href)),
                            "segments": activateDeactivateClasses._embedded.segmentClasses[k]
                        });
                    }
                }
            }
        }

        vm.saveActivateDeactivate = function (isValid, saveActivateDeactivate) {
            if (isValid) {
                //saveActivateDeactivate[0].segmentClassIds = saveActivateDeactivate[0].selectCheckBox;

                var save = {"segmentClassADs": saveActivateDeactivate};
                revenueProductionService.updateActivateDeactivateClass(save, vm.userAccount.userName)
                    .then(function (result) {
                        vm.cancel();
                    });
            }
        }
    }

    function getIndexClass(classId,segmentClass){
        var res = 0;
        if(segmentClass != undefined) {
            for (var i = 0; i < segmentClass.length; i++) {
                if (segmentClass[i].classId == classId) {
                    res = i;
                    break;
                }
            }
        }
        return res;
    }
})();
